import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Sends a Meta Pixel PageView when the route changes inside the app.
 *
 * The pixel snippet in index.html fires PageView once, on the full page load.
 * Moving from the home page to /demo is a client-side navigation with no page
 * load, so without this Meta would never see the demo page at all.
 *
 * The first render is skipped because index.html has already counted it.
 * Hash-only changes (/#pricing) are not new pages and are ignored. Does
 * nothing when fbq is absent, which is the case off the live hostname.
 */
export default function MetaPixelRouteTracker() {
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    if (typeof window.fbq === 'function') window.fbq('track', 'PageView');
  }, [pathname]);

  return null;
}
